export const MAX_ACTIVE_PLANS = 3;
export const MAX_OBJECTIVES = 15;
export const MAX_TASKS = 15;